import { IoChevronForwardOutline } from 'react-icons/io5'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { Body, BodyColor, BodyType, Button, ButtonTheme, ButtonVariant, Card, CardSize, CardVariant, Heading, TypographyColor, TypographyType } from '../../ui-elements'
import { useMapHelpers } from '../../helpers'
import { RouteConstants } from '../../constants'
import { userCurrencyState } from '../../states'

interface FeaturedStoriesProps {
    featuredStories: any[]
}

export const FeaturedStories = ({ featuredStories }: FeaturedStoriesProps) => {
    const { findHighestSpendingCategory, getCurrencyWithSymbol } = useMapHelpers();
    const [searchParams] = useSearchParams();
    const selCurrency = useRecoilValue(userCurrencyState);
    const navigate = useNavigate();
    const navigateToStory = (familyId: string) => {
        searchParams.set('family_id', familyId);
        navigate({
            pathname: RouteConstants.story_details,
            search: `?${searchParams.toString()}`,
        });
    }
    return (
        <div style={{ width: '100%', height: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'start', alignItems: 'center', overflowX: 'auto', overflowY: 'hidden', gap: 5 }} className='no-scrollbar'>
            {featuredStories?.length > 0 && featuredStories.map((story: any) => (
                <Card
                    size={CardSize.small}
                    variant={CardVariant.bordered}
                    classname='d-flex flex-row align-items-center padding-2 width-20-196vw height-6-99vw cursor-pointer'
                    style={{ flex: '0 0 auto' }}
                    key={story?.properties?.familyName}
                    onClick={() => navigateToStory(story?.properties?.familyId)}
                >
                    <div style={{
                        width: '9.864vw',
                        height: '100%',
                        display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems: 'center', borderRadius: '0.396vw',
                        overflow: 'hidden'
                    }}>
                        <img src={story?.properties?.image?.[0]} alt={`${story?.properties?.familyName}'s image`} className='h-100 w-100' style={{ objectFit: 'cover' }} />
                    </div>
                    <div style={{ width: '11.88vw', height: '', display: 'flex', flexDirection: 'column', justifyContent: 'start', alignItems: 'start', marginLeft: '0.5vw' }}>
                        <Heading
                            title={story?.properties?.familyName}
                            type={TypographyType.h6}
                            colour={TypographyColor.primary}
                            classname='text-start text-truncate'
                        />
                        <Body
                            type={BodyType.p3}
                            color={BodyColor.secondary}
                            classname='text-start'
                        >
                            {`${story?.properties?.familyDetails?.familyMembers ? story?.properties?.familyDetails?.familyMembers : 0} Members`}
                        </Body>
                        <Body
                            type={BodyType.p3}
                            color={BodyColor.secondary}
                            classname='text-start'
                        >
                            <b>{getCurrencyWithSymbol(findHighestSpendingCategory(story?.properties?.familyDetails, 'value'), selCurrency)}</b> Annual Household Spend on {findHighestSpendingCategory(story?.properties?.familyDetails, 'name')}
                        </Body>
                        <Button
                            theme={ButtonTheme.primary}
                            variant={ButtonVariant.transparent}
                            type='button'
                            classname='h-auto padding-0 text-underline fs-12 button-gray'
                            onClick={() => navigateToStory(story?.properties?.familyId)}
                        >
                            Read more
                            <IoChevronForwardOutline className='fs-12 margin-left-3' />
                        </Button>
                    </div>
                </Card>
            ))}
        </div>
    )
}

